import { NavLinks } from '@iveco-ti/iveco-ds'
import { ShieldBan } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router'
import { toast } from 'react-toastify'

import { Toast } from '../components/Toast'
import { ROUTES } from '../constants/routes'
import { usePermissions } from '../hooks/usePermissions'

export function RegistersLayout() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { cannot } = usePermissions()

  const handleNavigate = (route: string) => {
    navigate(route)
  }

  if (cannot('access', 'Registers')) {
    toast(Toast, {
      toastId: 'registers_access_denied',
      data: {
        type: 'danger',
        icon: ShieldBan,
        title: t('access_denied.title'),
        description: t('access_denied.description'),
      },
    })

    return <Navigate to={ROUTES.PANEL.NEWS} replace />
  }

  return (
    <>
      <NavLinks.Root>
        <p className="text-lg text-brand-900 font-semibold mr-8">
          {t('registers_layout.title')}
        </p>

        <NavLinks.Link
          onClick={() => handleNavigate(ROUTES.REGISTERS.USERS)}
          active={pathname === ROUTES.REGISTERS.USERS}
        >
          {t('registers_layout.menus.users')}
        </NavLinks.Link>

        <NavLinks.Link
          onClick={() => handleNavigate(ROUTES.REGISTERS.FILES)}
          active={pathname === ROUTES.REGISTERS.FILES}
        >
          {t('registers_layout.menus.files')}
        </NavLinks.Link>
      </NavLinks.Root>

      <Outlet />
    </>
  )
}
